import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Typography,
  DialogContentText,
  Box,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ModalLoadingOverlay, {
  modalLoadingContainerSx,
} from "./ModalLoadingOverlay";

const PauseResumeCanidateDrawer = ({
  open,
  basicInfo,
  handleClose,
  handleDelete,
  acknowledged,
  handleAcknowledgeChange,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await handleDelete();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: modalLoadingContainerSx(submitting, {
          padding: "20px 30px 20px 30px",
          borderRadius: "8px",
        }),
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          position: "relative",
        }}
      >
        <span
          style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            borderRadius: "50%",
            backgroundColor: "#EAF4FE",
            cursor: "pointer",
          }}
          onClick={handleClose}
        >
          <CloseIcon />
        </span>
      </div>
      <Typography
        style={{
          fontWeight: 500,
          textAlign: "center",
          fontSize: "16px",
          fontStyle: "normal",
          lineHeight: "24px",
          marginTop: "8px",
        }}
      >
        {`Are you sure, you want to ${
          basicInfo?.is_pause ? "resume" : "pause"
        }`}
        <span
          style={{
            fontWeight: 700,
            color: "#3394EF",
            textTransform: "capitalize",
          }}
        >
          {" "}
          {basicInfo?.firstName} {basicInfo?.lastName}
          {" ( "}
          {basicInfo?.role_name}
          {" )"} {"?"}
        </span>
      </Typography>

      <DialogContent>
        <DialogContentText>
          {/* <img
            src={"/Userdelete.svg"}
            alt="Delete Icon"
            style={{ display: "block", margin: "0 auto 16px" }}
          /> */}
          <Box
            style={{
              padding: "10px 20px",
              backgroundColor: "#FF4D4F1A",
              borderRadius: "8px",
            }}
          >
            <Typography
              style={{ fontWeight: 500, fontSize: "16px", color: "#FF4D4F" }}
            >
              Implications of Pausing a User
            </Typography>
            <Typography
              varient="body1"
              style={{
                fontWeight: 400,
                color: "black",
                marginTop: "10px",
                fontSize: "14px",
                paddingLeft: "4px",
              }}
            >
              • The user will be immediately logged out from their account.
            </Typography>
            <div className="d-flex">
              <Typography
                variant="body1"
                style={{
                  fontWeight: 400,
                  color: "black",
                  marginTop: "10px",
                  fontSize: "14px",
                  paddingLeft: "4px",
                }}
              >
                •
              </Typography>
              <Typography
                variant="body1"
                style={{
                  fontWeight: 400,
                  color: "black",
                  marginTop: "10px",
                  fontSize: "14px",
                  paddingLeft: "4px",
                }}
              >
                The user will no longer be able to log in until their account is
                resumed.
              </Typography>
            </div>
            <Typography
              variant="body1"
              style={{
                fontWeight: 400,
                color: "black",
                marginTop: "10px",
                fontSize: "14px",
                paddingLeft: "4px",
              }}
            >
              • The user’s data will be saved and not removed.
            </Typography>
            <Typography
              variant="body1"
              style={{
                fontWeight: 400,
                color: "black",
                marginTop: "10px",
                fontSize: "14px",
                paddingLeft: "4px",
              }}
            >
              • The user can be resumed at any time by an authorized admin.
            </Typography>
            <div className="d-flex">
              <Typography
                variant="body1"
                style={{
                  fontWeight: 400,
                  color: "black",
                  marginTop: "10px",
                  fontSize: "14px",
                  paddingLeft: "4px",
                }}
              >
                •
              </Typography>
              <Typography
                variant="body1"
                style={{
                  fontWeight: 400,
                  color: "black",
                  marginTop: "10px",
                  fontSize: "14px",
                  paddingLeft: "4px",
                }}
              >
                Once resumed, the user will regain access to their account and
                all associated data.
              </Typography>
            </div>
          </Box>
        </DialogContentText>

        <FormControlLabel
          control={
            <Checkbox
              checked={acknowledged}
              onChange={handleAcknowledgeChange}
            />
          }
          label={
            <span style={{ fontWeight: 500, fontSize: "16px" }}>
              I acknowledge the implications and wish to proceed.
            </span>
          }
        />
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: "center",
          display: "flex",
          gap: "30px",
          padding: "0 25px",
        }}
      >
        <Button
          className="cancel-btn"
          onClick={handleClose}
          variant="outlined"
          fullWidth
          style={{ borderRadius: "8px", textTransform: "capitalize" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="error"
          disabled={!acknowledged}
          fullWidth
          style={{ borderRadius: "8px", textTransform: "capitalize" }}
        >
          {`${basicInfo?.is_pause ? "Resume" : "Pause"}`}
        </Button>
      </DialogActions>
      <ModalLoadingOverlay open={submitting} />
    </Dialog>
  );
};

export default PauseResumeCanidateDrawer;
